import React from 'react';
import { Select } from 'antd';
import { Form } from '@common/components';
import { selectInputFilterHelper } from '@common/services';

type ComplianceTemplateType = {
  id: string;
  name: string;
};

export function ComplianceListTemplateSelect({
  complianceTemplates,
}: {
  complianceTemplates: ComplianceTemplateType[];
}) {
  return (
    <Form.Item
      label="Compliance Template"
      name="worksListTemplateId"
      colon={false}
      rules={[
        { required: true, message: 'Please select a compliance list template' },
      ]}
    >
      <Select
        showSearch
        size="large"
        filterOption={selectInputFilterHelper}
        placeholder="Select a Compliance List Template..."
        getPopupContainer={(trigger) => trigger.parentNode}
      >
        {complianceTemplates.map(({ id, name }) => {
          return (
            <Select.Option key={id} value={id}>
              {name}
            </Select.Option>
          );
        })}
      </Select>
    </Form.Item>
  );
}
